import styled from 'styled-components';
import themeResponsiveProperty from '../responsive/themeResponsiveProperty';

export default styled.div`
  position: relative;
  padding-top: ${themeResponsiveProperty('1rem', null)};
`;
